import { analytics, db, storage, auth, authProvider,
         adminDbPath, usersDbPath, imageDataDbPath } from "../firebaseConfig"
import { addDoc, collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore"


export default function Trade() {
    
    
    
    
    return (
        <div id="trade">
            <h1>trade page</h1>
        </div>
    )
}
